import { LoginV2 as PureLoginV2 } from '../../lib/user/account_service';
import { setConfig } from './config';
import { logger } from './logger';
/**
 * login
 * @param request
 */
export const LoginV2 = function LoginV2(request) {
    return PureLoginV2(request).then((data) => {
        logger.info(`login set token: ${!!data.token}`, 'interface:login');
        setConfig({ token: data.token });
        return data;
    });
};
